"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallButtonContainer = exports.ButtonContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const core_1 = require("@emotion/core");
const theme_style_1 = require("../../../theme.style");
const ButtonContainer = styled_1.default.div `
  text-align:center;
  min-width: 250px;
  ${(props) => props.fullWidth
    ? core_1.css `
          width: calc(100% - 74px);

          ${theme_style_1.device.tablet `
      width: calc(100% - 44px);
    `}
        `
    : core_1.css `
          width: fit-content;
        `};
  height: ${(props) => (props.square ? '80px' : '52px')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  ${(props) => !props.inverted &&
    core_1.css `
      background: ${props.theme.colors.primary};
    `}
  ${(props) => props.white &&
    !props.inverted &&
    core_1.css `
      background: white;
    `}
  
  ${(props) => !props.disabled &&
    !props.noBorder &&
    core_1.css `
      border: 1px solid ${props.white ? 'white' : props.theme.colors.primary};
    `};
  
  ${(props) => !props.square &&
    core_1.css `
      border-radius: 50px;
    `}

  padding-left: 34px;
  padding-right: 34px;

  color: ${(props) => (props.inverted && !props.white) || (props.white && !props.inverted) ? props.theme.colors.primary : 'white'};

  ${(props) => props.disabled &&
    !props.submitting &&
    core_1.css `
      background-color: ${props.theme.colors.primary}25;
      ${props.allowClick ? '' : 'pointer-events:none;'};
      color: ${props.theme.colors.primary};
    `}

  ${(props) => !props.disabled &&
    !props.submitting &&
    core_1.css `
      :hover {
        filter: brightness(120%);
      }
    `}

  ${theme_style_1.device.tablet `
    height: 44px;
    padding-left: 19px;
    padding-right: 19px;
    #min-width: 250px;
  `}
}
`;
exports.ButtonContainer = ButtonContainer;
const SmallButtonContainer = styled_1.default(ButtonContainer) `
  height: 28px !important;
  min-width: 96px;
  font-size: 12px;
  padding: 0px;
`;
exports.SmallButtonContainer = SmallButtonContainer;
